<p-card header="" subheader="" styleClass="ui-card-light" >

    <label>{{enrollmentLinkAttribute.key}}</label>

    <textarea pTextarea [id]="enrollmentLinkAttribute.value" style="width: 100%;" >{{enrollmentLinkAttribute.value}}</textarea>

</p-card>

